export default __webpack_public_path__ + "static/media/avatar.522560c8.png";